import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "h-full"
};
var _hoisted_2 = {
  class: "activity-sharing-main"
};
var _hoisted_3 = {
  class: "go-to-use"
};
var _hoisted_4 = {
  class: "flex justify-center"
};
import { ref, computed } from "vue";
import ShareCouponInfo from "@/components/activity/ShareCouponInfo.vue";
import { isLogin } from "@/utils/authUtil";
import { participateSendCouponActivity } from "@/api/activity";
import { useRouter } from "@/hooks/useRouter";
import { USER_ALREADY_PARTICIPATED_ACTIVITY } from "@/constant/responseCode";
import { showToast } from "@/utils/toastUtil";
import LoopSwipe from "@/components/activity/LoopSwipe.vue";
import Dialog from "@/components/activity/dialog";
import { Login } from "@/components/login/LoginDialog";
import { useI18n } from "vue-i18n";
export default {
  __name: 'SendCoupon',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var activityInfo = ref(window.__ACTIVITY_INFO__);
    var couponInfo = computed(function () {
      return activityInfo.value.sharer_reward_coupon;
    });
    function handleGetCoupon() {
      if (isLogin()) {
        afterLogin();
      } else {
        Login.open({
          onSuccess: function onSuccess() {
            afterLogin();
          }
        });
      }
    }
    function afterLogin() {
      return _afterLogin.apply(this, arguments);
    }
    function _afterLogin() {
      _afterLogin = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return participateSendCouponActivity({
                activity_id: activityInfo.value.activity_id
              });
            case 2:
              res = _context.sent;
              if (res.isOK) {
                showToast("Success", 900);
                setTimeout(function () {
                  window.location.replace("".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/home/index"));
                  window.location.assign("".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/my_coupon"));
                }, 1000);
              } else if (res.code === USER_ALREADY_PARTICIPATED_ACTIVITY) {
                Dialog.confirm({
                  title: t("alreadyParticipatedInThisActivity"),
                  okText: t("getMoreVouchers"),
                  withoutCancel: true,
                  closeOnClickOverlay: false,
                  onOk: handleGoHome
                });
              } else {
                Dialog.confirm({
                  title: t("activityHasExpired"),
                  okText: t("getMoreVouchers"),
                  withoutCancel: true,
                  closeOnClickOverlay: false,
                  onOk: handleGoHome
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _afterLogin.apply(this, arguments);
    }
    function handleGoHome() {
      routerPush({
        name: "Index"
      });
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(ShareCouponInfo, {
        title: _ctx.$t('getAVoucher', [couponInfo.value.title]),
        "discount-type": couponInfo.value.discount_type,
        "discount-rule": couponInfo.value.discount_rule,
        "button-text": _ctx.$t('getItNow'),
        onClickButton: handleGetCoupon
      }, null, 8, ["title", "discount-type", "discount-rule", "button-text"])])])]), _createVNode(LoopSwipe)]);
    };
  }
};